<template>
  <el-dialog
    v-model="visible"
    title="应用更新"
    width="400px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div style="text-align: center; padding: 20px 0;">
      <el-icon :size="48" color="#409EFF" style="margin-bottom: 16px;">
        <Refresh />
      </el-icon>
      <p style="font-size: 16px; margin-bottom: 8px;">发现新版本</p>
      <p style="color: #909399; font-size: 14px;">应用已更新，请刷新页面以使用最新版本</p>
    </div>
    <template #footer>
      <div style="text-align: center;">
        <el-button @click="handleUpdate">立即更新</el-button>
        <el-button type="primary" @click="handleLater">稍后更新</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { Refresh } from '@element-plus/icons-vue'
// 改为动态导入，与 pwa.js 保持一致，避免混合导入警告
// import { registerSW } from 'virtual:pwa-register'

const visible = ref(false)
let updateSW = null

onMounted(async () => {
  // 只在生产环境注册Service Worker
  if (import.meta.env.PROD) {
    try {
      // 动态导入 registerSW，与 pwa.js 保持一致
      const { registerSW } = await import('virtual:pwa-register')
      if (registerSW && typeof registerSW === 'function') {
        // 注册Service Worker更新回调
        updateSW = registerSW({
          immediate: true,
          onNeedRefresh() {
            visible.value = true
          },
          onOfflineReady() {
            console.log('应用已准备好离线使用')
          }
        })
      }
    } catch (error) {
      console.warn('⚠️ 无法加载 virtual:pwa-register:', error)
    }
  }

  // 监听自定义事件
  window.addEventListener('sw-update-available', () => {
    visible.value = true
  })
})

onUnmounted(() => {
  window.removeEventListener('sw-update-available', () => {})
})

const handleUpdate = () => {
  if (updateSW) {
    updateSW(true) // 立即更新并刷新
  } else {
    window.location.reload()
  }
}

const handleLater = () => {
  visible.value = false
}
</script>

<style scoped>
</style>

